import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  // Back/Forward returns to the scroll offset the user left a view at
  // (the fantasy tabs' drill-ins are same-route query navigations, where
  // the browser restores nothing on its own). Push/replace navigations
  // keep the current offset, as the site has always behaved.
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? false
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue')
    },
    {
      path: '/game',
      name: 'game',
      component: () => import('@/views/GameView.vue')
    },
    {
      path: '/trivia',
      name: 'trivia',
      component: () => import('@/views/TriviaView.vue')
    },
    {
      path: '/fantasy',
      name: 'fantasy',
      component: () => import('@/views/FantasyView.vue')
    },
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/views/UploadPack.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: () => import('@/views/AuthCallback.vue')
    }
  ]
})

export default router
